var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuKebabVerticalWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu-kebab-vertical") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 5C10.5 4.17157 11.1716 3.5 12 3.5H12.01C12.8384 3.5 13.51 4.17157 13.51 5V5.01C13.51 5.83843 12.8384 6.51 12.01 6.51H12C11.1716 6.51 10.5 5.83843 10.5 5.01V5ZM10.5 12C10.5 11.1716 11.1716 10.5 12 10.5H12.01C12.8384 10.5 13.51 11.1716 13.51 12V12.01C13.51 12.8384 12.8384 13.51 12.01 13.51H12C11.1716 13.51 10.5 12.8384 10.5 12.01V12ZM12 17.5C11.1716 17.5 10.5 18.1716 10.5 19V19.01C10.5 19.8384 11.1716 20.51 12 20.51H12.01C12.8384 20.51 13.51 19.8384 13.51 19.01V19C13.51 18.1716 12.8384 17.5 12.01 17.5H12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuKebabVerticalWhite);
export default __webpack_public_path__ + "static/media/menu-kebab-vertical-white.7ff578fd1fe13d01d2d72417fe9ccd7d.svg";
export { ForwardRef as ReactComponent };